// REDIRECT URLS (AKS URLs)
export const LOCALHOST_URL = "http://localhost:3000/terms";
export const DEV_URL =
  "https://gm-energy-systems-dev.cdn-dev.gm.com/energy/systems/products/installer/terms";
export const TEST_URL =
  "https://gmenergy-gm-com.stage.acp.gm.com/energy/systems/products/installer/terms";
export const PROD_URL =
  "https://gmenergy.gm.com/energy/systems/products/installer/terms";

// CAPS
export const CAPS_INSTANCE_DEV = "https://custlogin.pp.gm.com/";
export const CAPS_INSTANCE_PROD = "https://custlogin.gm.com/";
export const CAPS_AUTHORITY_DEV ="https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/b2c_1a_seamlessmigration_signuporsignin";
export const CAPS_AUTHORITY_PROD ="https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/b2c_1a_seamlessmigration_signuporsignin";
export const CAPS_APPLICATION_ID_DEV = "16535589-7634-4e3f-82fb-bd963a1e79e1";
export const CAPS_APPLICATION_ID_PROD = "700470b9-2d48-4604-8c47-65549d0e88f0";

// CAPS - EEID migration (B2C --> EEID)
// export const CAPS_INSTANCE_DEV = "https://ciamlogin.pp.gm.com/";
// export const CAPS_INSTANCE_PROD = "https://ciamlogin.gm.com/";
// export const CAPS_AUTHORITY_DEV =
//   "https://ciamlogin.pp.gm.com/1b84deee-7bd0-4f65-9659-6f620dcac84a";
// export const CAPS_AUTHORITY_PROD =
//   "https://ciamlogin.gm.com/ec1eeb88-cfcd-4735-9b8a-a0e63fd6d5ec";
// export const CAPS_APPLICATION_ID_DEV = "b6688124-56a0-4db7-9bc6-718463fcd88d";
// export const CAPS_APPLICATION_ID_PROD = "700470b9-2d48-4604-8c47-65549d0e88f0"; // WILL NEED TO BE UPDATED BEFORE PROD RELEASE

//API Endpoint (AKS URLs)

export const API_ENDPOINT_DEV =
  "https://euss-aks-d2-dev.musea2.azure.ext.gm.com";
export const API_ENDPOINT_TEST =
  "https://euss-aks-t2-tst.musea2.azure.ext.gm.com";
export const API_ENDPOINT_PROD = "https://euss-aks-p2.musea2.azure.ext.gm.com";

// QR Value URLs (AKS URLs)
export const QR_VALUE_LOCALHOST = "http://localhost:3000/";
export const QR_VALUE_DEV =
  "https://gm-energy-systems-dev.cdn-dev.gm.com/energy/systems/products/customer/";
export const QR_VALUE_TEST =
  "https://gmenergy-gm-com.stage.acp.gm.com/energy/systems/products/customer/";
export const QR_VALUE_PROD =
  "https://gmenergy.gm.com/energy/systems/products/customer/";

  // based urls
export const BASE_LOCALHOST_URL = "http://localhost:3000/";
export const BASE_DEV_URL =
  "https://gm-energy-systems-dev.cdn-dev.gm.com/energy/systems/products/installer/";
export const BASE_TEST_URL =
  "https://gmenergy-gm-com.stage.acp.gm.com/energy/systems/products/installer/";
export const BASE_PROD_URL =
  "https://gmenergy.gm.com/energy/systems/products/installer/";
